export default __webpack_public_path__ + "static/media/LineChart.8039572d.svg";